module.exports = __webpack_public_path__ + "static/media/2474215.b3bbb55f.jpg";